var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 6.333c0-.995.783-1.833 1.786-1.833h15.428c1.004 0 1.786.838 1.786 1.833v11.334c0 .995-.782 1.833-1.786 1.833H4.286c-1.003 0-1.786-.838-1.786-1.833V6.333Zm1 2.544v8.79c0 .477.369.833.786.833h15.428c.417 0 .786-.356.786-.833v-8.79l-8.245 4.886a.5.5 0 0 1-.51 0L3.5 8.878Zm17-1.162V6.333c0-.477-.369-.833-.786-.833H4.286c-.417 0-.786.356-.786.833v1.382l8.5 5.037 8.5-5.037Z",
  fill: "currentColor"
})));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "54c3d742c94d9be35e349a13f76cc42e.svg";